const R = require('ramda');

const capitalize = R.converge(R.concat, [R.compose(R.toUpper, R.head), R.tail]);

const toTitleCase = R.compose(R.join(' '), R.map(capitalize), R.split(' '));

module.exports = toTitleCase;
